import { Trans } from "@lingui/macro";
import { IApiEntitySmpAgTemplate } from "@smp/api";
import { UiButtonBase, UiTypography } from "@smp/ui";
import { IconArrowUpRight } from "@tabler/icons-react";
import { forwardRef, useCallback, useMemo, useState } from "react";

import { IVirtualItem } from "@/components/features/polotno_templates";
import { useContextPolotnoTemplates } from "@/components/features/polotno_templates/context";
import { HelperAdapterLink } from "@/components/helpers/helper_adapter_link";
import { useSmpAgTranslation } from "@/hooks/use_smp_ag_translation";
import { useQueryPolotnoTagsAll } from "@/queries/polotno/use_query_polotno_tags_all";
import { customGeneratePath } from "@/utils";

import { useStyles } from "./template_card.css";

type ITemplateCardProps = {
  template: IVirtualItem<IApiEntitySmpAgTemplate>;
};

export const TemplateCard = forwardRef<any, ITemplateCardProps>(
  ({ template }, ref) => {
    const classes = useStyles();
    const getTranslation = useSmpAgTranslation();
    const [isImgLoaded, setImgLoaded] = useState(false);

    const {
      state: { pathPattern, isRoutingDisabled, isWidget },
      actions: { setActiveEntity },
    } = useContextPolotnoTemplates();

    const {
      data: { normalized: normalizedTags },
    } = useQueryPolotnoTagsAll();

    const authorTag = useMemo(() => {
      const slug = template.tags.find((tag) => tag.startsWith("author"));

      return slug && normalizedTags ? normalizedTags?.get(slug) : undefined;
    }, [normalizedTags, template.tags]);

    const handleClick = useCallback(() => {
      if (!isRoutingDisabled) {
        return;
      }

      setActiveEntity(String(template.id));
    }, [isRoutingDisabled, setActiveEntity, template.id]);

    return (
      <UiButtonBase
        className={classes.wrapper}
        ref={isImgLoaded ? ref : undefined}
        component={!isRoutingDisabled || isWidget ? HelperAdapterLink : "div"}
        to={customGeneratePath(pathPattern, {
          templateId: template.id,
        })}
        onClick={handleClick}
        target={isWidget ? "_blank" : undefined}
      >
        <img
          src={template.preview_url}
          alt=""
          className={classes.image}
          onLoad={() => setImgLoaded(true)}
          width={template.meta?.width}
          height={template.meta?.height}
        />
        {!import.meta.env.SSR && !isWidget && (
          <div className={classes.overlay}>
            <div className={classes.favorite_button}>{/* <IconStar /> */}</div>
            <div className={classes.text_edit}>
              <UiTypography>
                <Trans>Edit template</Trans>
              </UiTypography>
              <IconArrowUpRight />
            </div>
            <div className={classes.caption}>
              <UiTypography className={classes.caption__text}>
                {template.template_name}
                {authorTag && (
                  <>
                    <br />
                    <Trans>by</Trans>{" "}
                    <b>{getTranslation(authorTag.translations)}</b>
                  </>
                )}
              </UiTypography>
            </div>
          </div>
        )}
      </UiButtonBase>
    );
  },
);
